import React from "react";
import { CardHeader, CardTitle } from 'reactstrap';

const divStyleHeader = {
    backgroundColor: '#fafafa'
};
const divStyleHeaderBorder = {
    borderBottom: '1px solid #ccc'
};

const divStyleFormGroup = {
    marginTop: '16px',
    marginBottom: '0px'
};
const divStyleIcon = {
    paddingRight: '10px',
    fontSize: '32px'
};


function SectionHeader(props) {
    return (
        <CardHeader>
            <i className={props.iconname}></i><label>{props.header}</label>
        </CardHeader>
    );
};

export default SectionHeader;